import { API } from './../constants'
import authService from './auth.js'

let anotados = null
let datos = null

const examenService = {
  /**
   * Retorna un array con todos los profesores
   *
   * @return {Promise<{}>}
   */
  async traerAnotadosMesaDeExamenPorServicioId (id) {
    const fetchResponse = await fetch(`${API}/anotados-mesa-examen/${id}`, {
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest',
        ...authService.tokenHeader()
      }
    })
    const respuesta = await fetchResponse.json()
    anotados = respuesta.data
    return [...anotados]
  },
  async traerDatosAnotadosExamen (id) {
    const fetchResponse = await fetch(`${API}/datos-inscripcion-examen/${id}`, {
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest',
        ...authService.tokenHeader()
      }
    })
    const respuesta = await fetchResponse.json()
    datos = respuesta.data
    return { ...datos }
  },
  cargarExamen (data) {
    return fetch(`${API}/cargar-resultado-examen`, {
      method: 'POST',
      body: JSON.stringify(data),
      headers: {
        'X-Requested-With': 'XMLHttpRequest',
        'Content-Type': 'application/json',
        ...authService.tokenHeader()
      }
    })
      .then(rta => rta.json())
      .then(respuesta => {
        return { ...respuesta }
      })
  }
}

export default examenService
